$(function () {
  $('.js-dropdown-click').on('click', function () {
    $(this).toggleClass('is_open');
    $(this).closest('.homeSec04-leaderList__item').find('.homeSec04-leaderList__dropdown').slideToggle();
    var target = $(this).closest('.homeSec04-leaderList__item');
    $('html, body').animate({ scrollTop: target.offset().top }, 300);
  });
});
